/* eslint-disable @typescript-eslint/no-explicit-any */
"use client";

import {
    FormControl,
    FormDescription,
    FormField,
    FormItem,
    FormMessage,
} from "@/shared/components/ui/form";
import { RadioGroup, RadioGroupItem } from "@/shared/components/ui/radio-group";
import { BaseFieldProps, Option } from "./form-field-utils";
import { FormFieldLabel } from "./form-field-label";

export function FieldRadioGroup({
    name,
    label,
    description,
    className,
    labelType = "text",
    tooltipContent,
    options = [] as Option[],
}: BaseFieldProps & { options?: Option[] }) {
    return (
        <FormField
            name={name}
            render={({ field }) => (
                <FormItem className={className}>
                    <FormFieldLabel label={label} labelType={labelType} tooltipContent={tooltipContent} />
                    <FormControl>
                        <RadioGroup ref={field.ref} value={field.value} onValueChange={field.onChange} className="flex gap-2">
                            {options.map((o) => (
                                <label
                                    key={o.value}
                                    className="inline-flex items-center gap-2 rounded-xl border px-3 py-2 cursor-pointer"
                                >
                                    <RadioGroupItem value={o.value} />
                                    <span>{o.label}</span>
                                </label>
                            ))}
                        </RadioGroup>
                    </FormControl>
                    {description && <FormDescription>{description}</FormDescription>}
                    <FormMessage />
                </FormItem>
            )}
        />
    );
}
